import template from './billing_category.create.html'
import controller from './billing_category.create.controller'
import './billing_category.create.scss'

const billingCategoryCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default billingCategoryCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/create/billing_category.create.component.js